import {
    CHANGE_ACCEPT_TERMS,
    CHANGE_PAYMENT_METHOD,
    CHANGE_EMAIL,
    CHANGE_RETYPE_EMAIL,
    CHANGE_NAME,
    CHANGE_SELECTED_COUNTRY,
    CHANGE_PHONE_NUMBER,
    RECEIVE_VALIDATE_FORM_RESPONSE
} from "../actions";
import orderDetails from './orderDetails'
import personalInfo from './personalInfo'
import {combineReducers} from "redux";

const initialState = {
    selectedPaymentMethod: 'creditCard',
    acceptTerms: false,
    countValidations: 0,
    validationErrors: {},
    isFormReadyForSubmit: false,
}

const app = (state = initialState, action) => {

    let newState

    switch (action.type) {
        case CHANGE_PAYMENT_METHOD:
            newState = Object.assign({}, state, {
                selectedPaymentMethod: action.paymentType
            })
            break
        case CHANGE_ACCEPT_TERMS:
            newState = Object.assign({}, state, {
                acceptTerms: !state.acceptTerms
            })
            newState = removeValidationError(newState, 'acceptTerms')
            break
        case RECEIVE_VALIDATE_FORM_RESPONSE:
            let validationErrors = action.response
            if (!state.acceptTerms) {
                validationErrors['acceptTerms'] = true
            }

            const isFormReadyForSubmit = Object.keys(validationErrors).length === 0

            newState = Object.assign({}, state, {
                countValidations: state.countValidations + 1,
                validationErrors: validationErrors,
                isFormReadyForSubmit: isFormReadyForSubmit,
            });
            break
        case CHANGE_EMAIL:
            newState = removeValidationError(state, 'email')
            break
        case CHANGE_RETYPE_EMAIL:
            newState = removeValidationError(state, 'retype_email')
            break
        case CHANGE_NAME:
            newState = removeValidationError(state, 'name')
            break
        case CHANGE_SELECTED_COUNTRY:
            newState = removeValidationError(state, 'country')
            break
        case CHANGE_PHONE_NUMBER:
            newState = removeValidationError(state, 'phone1')
            newState = removeValidationError(newState, 'phone1_number')
            break
        default:
            newState = state
    }

    return Object.assign({}, newState, {
        orderDetails: orderDetails(newState.orderDetails, action),
        personalInfo: personalInfo(newState.personalInfo, action)
    })
}

export default app

function removeValidationError(state, fieldName) {
    let validationErrors = Object.assign({}, state.validationErrors)
    delete validationErrors[fieldName]
    return Object.assign({}, state, {
        validationErrors: validationErrors,
    });
}